import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { EmptyLine } from './styled';
import { createPrice, GroupTypesB2C, Status } from '../helpers/product';
import { formatDate, PagePath, redirectWithQueryParams } from '../helpers/util';
import { modalActions } from '../store/ducks/modal';
import { Box, ButtonCTA, Header, Info, Title, ExtraInfo } from './styled/PlanCTA';

const mapStateToProps = (state: any) => ({
  prescription: state.appData.prescription,
  language: state.appData.language,
  subscription: state.appData.subscription,
  products: state.appData.general.products,
  locationQuery: state.router.location.query,
  currency: state.appData.currency,
});

interface DispatchProps {
  toggleUpgradeSubscriptionModal: (isOpen: boolean) => void;
  toggleCancelDowngradeModal: (isOpen: boolean) => void;
}
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps & DispatchProps;

class PlanCTA extends React.Component<Props> {
  getButtonTitleKey = (groupType: GroupTypesB2C) => {
    switch (groupType) {
      case GroupTypesB2C.FREE_TRIAL:
        return 'add_subscription';
      case GroupTypesB2C.ESSENTIAL:
        return 'upgrade_to_premium';
      case GroupTypesB2C.PREMIUM:
        return 'stay_in_premium';
      default:
        return '';
    }
  }

  handleCTAButton = () => {
    const { prescription } = this.props;
    if (prescription.type === GroupTypesB2C.FREE_TRIAL) {
      redirectWithQueryParams(PagePath.plans, this.props.locationQuery);
    }

    if (prescription.type === GroupTypesB2C.ESSENTIAL) {
      this.props.toggleUpgradeSubscriptionModal(true);
    } else if (prescription.type === GroupTypesB2C.PREMIUM) {
      this.props.toggleCancelDowngradeModal(true);
    }
  };

  render() {
    const { prescription, subscription, products } = this.props;
    const active = subscription?.status === Status.ACTIVE;
    const hideButton: boolean = (subscription?.plan === GroupTypesB2C.PREMIUM && prescription.type === GroupTypesB2C.PREMIUM) ||
    (prescription.type === GroupTypesB2C.PREMIUM && !active);

    return (
      <Box>
        <Header>
          <Info>
            { !active && <EmptyLine /> }
            { subscription?.billingPeriod && active && <FormattedMessage id={`${subscription?.billingPeriod}_billing`} /> }
          </Info>
          <Title><FormattedMessage id={prescription.type} /></Title>
          { !active && prescription?.type === GroupTypesB2C.FREE_TRIAL && <FormattedMessage id="premium_plan_experience" /> }
          {
            active && (
              <FormattedMessage id="month">
                { month => <>{ `${createPrice(products, prescription.type, subscription.billingPeriod, this.props.currency, true)}/${month}` }</> }
              </FormattedMessage>
            )
          }
        </Header>
        {
          !hideButton && (
            <>
              {
                prescription?.type === GroupTypesB2C.PREMIUM && (
                  <ExtraInfo>
                    <FormattedMessage id="will_downgrade_to_essential_on">
                      { message => <>{ `${message} ${formatDate(prescription.end)}` }</> }
                    </FormattedMessage>
                  </ExtraInfo>
                )
              }
              <ButtonCTA gold={this.props.prescription.type === GroupTypesB2C.ESSENTIAL} onClick={this.handleCTAButton}>
                <FormattedMessage id={this.getButtonTitleKey(prescription.type)} />
              </ButtonCTA>
            </>
          )
        }
      </Box>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, modalActions)(PlanCTA);
